import { render, staticRenderFns } from "./slot-widget.vue?vue&type=template&id=de765818&scoped=true"
import script from "./slot-widget.vue?vue&type=script&lang=js"
export * from "./slot-widget.vue?vue&type=script&lang=js"
import style0 from "./slot-widget.vue?vue&type=style&index=0&id=de765818&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de765818",
  null
  
)

export default component.exports